import { render, staticRenderFns } from "./Plug.vue?vue&type=template&id=243fac2e&scoped=true"
import script from "./Plug.vue?vue&type=script&lang=js"
export * from "./Plug.vue?vue&type=script&lang=js"
import style0 from "./Plug.vue?vue&type=style&index=0&id=243fac2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243fac2e",
  null
  
)

export default component.exports